//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.LOCATION_BUTTONS.UPDATE:
      return model.update(state, action.payload)
    case TYPES.LOCATION_BUTTONS.DELETE:
      return model.update(state, initialState)
    default:
      return state
  }
}
